import PropTypes from 'prop-types';
import { useContext } from 'react';
import styled from 'styled-components';

import { AppContext } from '../context/AppContext';
import { min } from '../utils/breakpoints';

const StyledH1 = styled.h1`
  margin-top: 10px;
  margin-bottom: 15px;

  ${min.sm} {
    margin-top: 5px;
    margin-bottom: 30px;
  }

  ${min.lg} {
    margin-top: 0;
    padding-top: 0;
    vertical-align: top;
    line-height: 0.9;
  }
`;

const AppCard = ({ children }) => {
  const { pageTitle } = useContext(AppContext);

  return (
    <>
      <StyledH1 className="pl-md-5 pl-sm-5 pl-lg-0">{pageTitle}</StyledH1>
      <div className="app-card">{children}</div>
    </>
  );
};

AppCard.propTypes = {
  children: PropTypes.node,
};

export default AppCard;
